let $ = require("jquery");
let Backbone = require("backbone");
let _ = require("underscore");
let DbRecorder = require("../recorder/DbRecorder.js");
let moment = require('moment');

let main = function () {
    return Backbone.Model.extend({
        defaults: {
            status: "Unread",
            level: "Normal",
            title: null,
            content: null,
            notifier: null,
            expiry: 0
        },
        initialize: function () {
        }
    });
};


let exportedValue = main();
module.exports = exportedValue;


// WEBPACK FOOTER //
// ./src/model/NotificationModel.js